import React, { useMemo, useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { RouteComponentProps } from '@reach/router';
import { Table } from '@organisms';
import { TextField } from '@atoms';
import { useDebouncedValue } from '@particles';
import { columns, generateRows } from './particles';
import { callGetExtensionReports } from '../../../../particles/api/extension';

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3)
}));

const SADiagnostics: React.FC<RouteComponentProps> = () => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebouncedValue(search.trim(), 350);
  const reportsQuery = useQuery({
    queryKey: ['extension-reports', 1, 50, debouncedSearch],
    queryFn: () => callGetExtensionReports(1, 50, debouncedSearch || undefined),
    placeholderData: keepPreviousData
  });

  const items = reportsQuery.data?.code === 200 ? reportsQuery.data.data?.data ?? [] : [];
  const isLoading = reportsQuery.isFetching;
  const rows = useMemo(() => generateRows(items), [items]);

  return (
    <StyledContainer maxWidth="xl">
      <Box sx={{ mb: 2, width: 360, maxWidth: '100%' }}>
        <TextField
          label={'Search name, email or company'}
          name={'search'}
          value={search}
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>
      <Table
        name="diagnostics"
        columns={columns}
        data={rows}
        isLoading={isLoading}
        noResultsMessage={debouncedSearch ? `No reports from a user matching "${debouncedSearch}"` : 'No error reports received yet'}
        persistColumnPrefs
      />
    </StyledContainer>
  );
};

export default SADiagnostics;
